export default __webpack_public_path__ + "img/consultation_apply-08abc2e47ad8231ccbc25fe3fbd6c0db.png";